import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handlePostCommentFailed(
  state: State,
  { discussion, comment }: Boundaries["postComment"]["failure"],
): State {
  return state.map((result) => ({
    ...result,
    discussions: result.discussions.map((d) =>
      d.uuid === discussion.uuid
        ? {
            ...d,
            comments: d.comments.filter(
              ({ uuid }) => uuid !== `__pending__${comment.content}`,
            ),
            commentsCount: Math.max(
              0,
              (d.commentsCount ?? d.comments.length) - 1,
            ),
          }
        : d,
    ),
  }));
}

export { handlePostCommentFailed };
